<footer>
    <div class="language__box__inner">
        <div class="copy__right">
            Telkomsel © {{thisYear}}
        </div>
        <div class="language__wrap">
            @for (item of langData; track item.value) {
                <div class="language " *ngIf="showLang.id" (click)="changeLang(item.value)">
                    <img [src]="item.image" [alt]="'lang-' + item.value">
                    <div class="lang__name" [ngClass]="{'lang__active': currentLang() == item.value}">{{item.title}}
                    </div>
                </div>
            }
        </div>
    </div>
</footer>